/**
 * Created by math_chao on 2017/2/17.
 */

var cwMjs=window.cwMjs || {};

cwMjs.column = {
    page : 1,

    init : function(){

    },

    createArticleList : function(articles){
        var $articleWrap = $('.js-article-list');
        if($articleWrap.length){
            $.each(articles, function(index, article){
                $articleWrap.append(cwMjs.column.createArticleElement(article));
            });
        }
    },

    createArticleElement : function(article){
        var content = '';
        if(article.imageList.length >= 3){
            content += '<li class="item-img-many clearfix">';
            content += '<a href="'+article.url+'" title="'+article.title+'" target="_self">';
            content += '<h3>'+article.title+'</h3>';
            content += '<div class="images clearfix">';
            $.each(article.imageList, function(index, image){
                content += '<img src="'+image+'" alt="'+article.title+'" >';
            });
            content += ' </div>';
            content += '</a >';
            content += '<div class="article-info">';
            content += '<span class="column">'+article.classname+'</span>';
            content += article.authorRender;
            content += ' <span class="date">'+article.newstime+'</span>';
            content += '</div>';
            content += '</li>';
        }else{
            if(article.titlepic){
                content += '<li class="item-img-single clearfix">';
                content += '<a class="img-box" href="'+article.url+'" title="'+article.title+'" target="_self">';
                content += '<img src="'+article.titlepic+'" alt="'+article.title+'" >';
                content += '</a >';
                content += '<div class="article-info">';
                content += ' <h3><a href="'+article.url+'" title="'+article.title+'" target="_self">'+article.title+'</a ></h3>';
                content += '<div>';
                content += article.authorRender;
                content += ' <span class="date">'+article.newstime+'</span>';
                content += '</div>';
                content += '</div>';
                content += '</li>';
            }else{
                content += '<li class="item-article clearfix">';
                content += '<div class="article-info">';
                content += ' <h3><a href="'+article.url+'" title="'+article.title+'" target="_self">'+article.title+'</a ></h3>';
                content += '<div>';
                content += article.authorRender;
                content += ' <span class="date">'+article.newstime+'</span>';
                content += '</div>';
                content += '</div>';
                content += '</li>';
            }
        }
        return $(content);
    },

    ajaxGetSectionArticles : function($loader){
        cwMjs.column.page ++;
        var request = $.ajax({
            url: '/ajax/article/section/load/',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page : cwMjs.column.page,
                sectionType : $loader.data('section')
            }
        });

        request.done(function(result){
            if(result.code == 200){
                if(result.data.articles.length == 0){
                    $loader.data('disable', '1');
                    $loader.html('没有更多文章了');
                }else{
                    cwMjs.column.createArticleList(result.data.articles);
                }
            }
        });
    },

    articleSectionLoad : function(){
        var $loader = $('.js-article-section-load');
        $loader.on('click', function(){
            if($loader.data('disable') != '1'){
                cwMjs.column.ajaxGetSectionArticles($loader);
            }
        });

    },

    createSearchArticleElement : function(article){
        var content = '';
        if(article.imageList.length >= 3){
            content += '<li class="item-img-many clearfix">';
            content += '<a href="'+article.url+'" title="'+article.title+'" target="_self">';
            content += '<h3>'+article.spanTitle+'</h3>';
            content += '<div class="images clearfix">';
            $.each(article.imageList, function(index, image){
                content += '<img src="'+image+'" alt="'+article.title+'" >';
            });
            content += ' </div>';
            content += '</a >';
            content += '<div class="article-info">';
            content += '<span class="column">'+article.classname+'</span>';
            content += article.authorRender;
            content += ' <span class="date">'+article.newstime+'</span>';
            content += '</div>';
            content += '</li>';
        }else{
            if(article.titlepic){
                content += '<li class="item-img-single clearfix">';
                content += '<a class="img-box" href="'+article.url+'" title="'+article.title+'" target="_self">';
                content += '<img src="'+article.titlepic+'" alt="'+article.title+'" >';
                content += '</a >';
                content += '<div class="article-info">';
                content += ' <h3><a href="'+article.url+'" title="'+article.title+'" target="_self">'+article.title+'</a ></h3>';
                content += '<div>';
                content += article.authorRender;
                content += ' <span class="date">'+article.newstime+'</span>';
                content += '</div>';
                content += '</div>';
                content += '</li>';
            }else{
                content += '<li class="item-article clearfix">';
                content += '<div class="article-info">';
                content += ' <h3><a href="'+article.url+'" title="'+article.title+'" target="_self">'+article.title+'</a ></h3>';
                content += '<div>';
                content += article.authorRender;
                content += ' <span class="date">'+article.newstime+'</span>';
                content += '</div>';
                content += '</div>';
                content += '</li>';
            }
        }
        return $(content);
    },

    ajaxGetSearchArticles : function($loader){
        cwMjs.column.page ++;
        var request = $.ajax({
            url: '/ajax/article/search/load/',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page : cwMjs.column.page,
                keywords : $loader.data('keywords')
            }
        });

        request.done(function(result){
            if(result.code == 200){
                if(result.data.articles.length == 0){
                    $loader.data('disable', '1');
                    $loader.html('没有更多文章了');
                }else{
                    var $articleWrap = $('.js-article-list');
                    if($articleWrap.length){
                        $.each(result.data.articles, function(index, article){
                            $articleWrap.append(cwMjs.column.createSearchArticleElement(article));
                        });
                    }
                }
            }
        });
    },

    articleSearchLoad : function(){
        var $loader = $('.js-article-search-load');
        $loader.on('click', function(){
            if($loader.data('disable') != '1'){
                cwMjs.column.ajaxGetSearchArticles($loader);
            }
        });

    },

    ajaxGetTopicArticles : function ($loader) {
        cwMjs.column.page ++;
        var request = $.ajax({
            url: '/ajax/topic/article/load/',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page : cwMjs.column.page,
                ztid : $loader.data('ztid')
            }
        });

        request.done(function(result){
            if(result.code == 200){
                if(result.data.articles.length == 0){
                    $loader.data('disable', '1');
                    $loader.html('没有更多文章了');
                }else{
                    cwMjs.column.createArticleList(result.data.articles);
                }
            }
        });
    },

    topicArticleLoad : function(){
        var $loader = $('.js-topic-article-load');
        $loader.on('click', function(){
            if($loader.data('disable') != '1'){
                cwMjs.column.ajaxGetTopicArticles($loader);
            }
        });

    },

    ajaxGetAuthorArticles : function ($loader) {
        cwMjs.column.page ++;
        var request = $.ajax({
            url: '/ajax/author/article/load/',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page : cwMjs.column.page,
                id : $loader.data('id')
            }
        });

        request.done(function(result){
            if(result.code == 200){
                if(result.data.articles.length == 0){
                    $loader.data('disable', '1');
                    $loader.html('没有更多文章了');
                }else{
                    cwMjs.column.createArticleList(result.data.articles);
                }
            }
        });
    },

    authorArticleLoad : function(){
        var $loader = $('.js-author-article-load');
        $loader.on('click', function(){
            if($loader.data('disable') != '1'){
                cwMjs.column.ajaxGetAuthorArticles($loader);
            }
        });

    },

    createAuthorList : function(authors){
        var $authorWrap = $('.js-author-list');
        if($authorWrap.length){
            $.each(authors, function(index, author){
                var content = '<li class="clearfix">';
                content += ' <a href="'+author.url+'" class="img-box" title="'+author.title+'" target="_self" >';
                content += '<img src="'+author.titlepic+'" alt="'+author.title+'" >';
                content += ' </a >';
                content += '<a href="'+author.url+'" class="author-info" title="'+author.title+'" target="_self" >';
                content += '<h3>'+author.title+'</h3>';
                content += '<div class="title">'+author.ftitle+'</div>';
                content += '<span class="article-count">文章'+author.articleCount+'篇</span>';
                content += '</a >';
                content += '</li>';
                $authorWrap.append($(content));
            });
        }
    },

    ajaxAuthorLoad : function($loader){
        cwMjs.column.page ++;
        var request = $.ajax({
            url: '/ajax/author/load/',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page : cwMjs.column.page
            }
        });

        request.done(function(result){
            if(result.code == 200){
                if(result.data.authors.length == 0){
                    $loader.data('disable', '1');
                    $loader.html('没有更多作者了');
                }else{
                    cwMjs.column.createAuthorList(result.data.authors);
                }
            }
        });
    },

    authorLoad : function(){
        var $loader = $('.js-author-load');
        $loader.on('click', function(){
            if($loader.data('disable') != '1'){
                cwMjs.column.ajaxAuthorLoad($loader);
            }
        });
    },

    createTopicList : function(topics){
        var $topicWrap = $('.js-topic-list');
        if($topicWrap.length){
            $.each(topics, function(index, topic){
                var content = '<li class="item-img-single clearfix">';
                content += '<a class="img-box" href="'+topic.url+'" title="'+topic.ztname+'" target="_self">';
                content += '<img src="'+topic.ztimg+'" >';
                content += ' </a >';
                content += '<div class="article-info">';
                content += '<h3><a href="'+topic.url+'" title="'+topic.ztname+'" target="_self">'+topic.ztname+'</a ></h3>';
                content += '<div>';
                content += '<span class="article-count">文章'+topic.articleCount+'篇</span>';
                content += '</div>';
                content += '</div>';
                content += ' </li>';
                $topicWrap.append($(content));
            });
        }
    },

    ajaxTopicLoad : function($loader){
        cwMjs.column.page ++;
        var request = $.ajax({
            url: '/ajax/topic/load/',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page : cwMjs.column.page
            }
        });

        request.done(function(result){
            if(result.code == 200){
                if(result.data.topics.length == 0){
                    $loader.data('disable', '1');
                    $loader.html('没有更多专题了');
                }else{
                    cwMjs.column.createTopicList(result.data.topics);
                }
            }
        });
    },

    topicLoad : function(){
        var $loader = $('.js-topic-load');
        $loader.on('click', function(){
            if($loader.data('disable') != '1'){
                cwMjs.column.ajaxTopicLoad($loader);
            }
        });
    }
};
